import * as vp from 'vopay';
import type { SupportedCurrencies } from 'vopay';

import { FunctionComponent } from 'react';
import styles from './InterestHistoryTable.module.scss';

const { formattedCurrency } = vp;

const { Box, withStyles, Table } = vp;
const classes = withStyles(styles);

type FC = FunctionComponent<InterestHistoryTableProps>;

type InterestHistoryTableProps = {
  interestAccruedDetails: vp.InterestAccruedDetail[];
  formatDate: (param: string) => string;
  hasLongTermAccount: boolean;
  currency: SupportedCurrencies;
};

type InterestDetailsTable = vp.InterestAccruedDetail & {
  InterestMaturityType: string;
};

const InterestHistoryTable: FC = ({ interestAccruedDetails, formatDate, hasLongTermAccount, currency }) => {
  return (
    <>
      <Box className={classes('interestHistoryTableContainer', 'scrollbar')}>
        <Table
          zebra
          id="interest-account-table"
          version="2"
          rows={
            interestAccruedDetails
              ? interestAccruedDetails.map((value, index) => {
                  const interestDetails = value as InterestDetailsTable;
                  return {
                    id: index,
                    data: {
                      dateAccrued: interestDetails.DateAccrued,
                      amountAccrued: `${currency} ${formattedCurrency(interestDetails.AmountAccrued)}`,
                      rate: interestDetails.Rate,
                      balanceForCalculation: `${currency} ${formattedCurrency(interestDetails.BalanceForCalculation)}`,
                      InterestMaturityType: interestDetails.InterestMaturityType,
                    },
                  };
                })
              : []
          }
          columns={[
            {
              id: 'accountType',
              header: 'Account Type',
              align: 'center',
              field: 'InterestMaturityType',
              visible: hasLongTermAccount,
              style: {
                textTransform: 'capitalize',
              },
            },
            {
              id: 'dateAccrued',
              header: 'Date',
              align: 'center',

              template: (interestDetails) => <p> {formatDate(interestDetails.data.dateAccrued)} </p>,
            },
            {
              id: 'balanceForCalculation',
              header: 'End of Day Eligible Balance',
              align: 'center',
              field: 'balanceForCalculation',
            },
            {
              id: 'rate',
              header: 'Interest Rate (%)',
              align: 'center',
              field: 'rate',
            },
            {
              id: 'amountAccrued',
              header: 'Interest Gained',
              align: 'center',
              field: 'amountAccrued',
            },
          ]}
        />
      </Box>
      {interestAccruedDetails.length === 0 && (
        <Box flx="col" jc="center">
          <Box ai="center" jc="center" pt="lg">
            There are no records to display within this date range
          </Box>
        </Box>
      )}
    </>
  );
};

export default InterestHistoryTable;
